<template>
    <div>
        <b-row>
            <b-col cols="12">
                <b-card class="mb-3" title="İlginizi Çekebilir">
                    <b-alert variant="warning" show class="mb-0">
                        <div class="alert-body mb-2">
                            <span><strong>Not:</strong>Anasayfada görüntülenecek 3 adet içerik seçin...</span>
                        </div>
                    </b-alert>
                </b-card>
            </b-col>
        </b-row>
        <validation-observer ref="rules">
            <b-row>
                <b-col cols="12">
                    <b-card class="mb-3" title="İlginizi Çekebilir">
                        <b-row>
                            <b-col>
                                <b-form-group label="Bağlantı Tipi" label-for="linkType">
                                    <validation-provider #default="{ errors }" :rules="{
                                      required: true
                                    }" name="Bağlantı Tipi">
                                        <v-select id="linkType" v-model="selectedSliderLinkType" label="name"
                                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                            :options="sliderLinkTypes" />
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12">
                                <b-row>
                                    <b-col>
                                        <b-form-group label="Kategori" label-for="category">
                                            <validation-provider #default="{ errors }" :rules="{
                                                required: true
                                            }" name="Kategori">
                                                <v-select id="category" v-model="selectedCategory" label="name"
                                                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                    :options="categories" />
                                                <small class="text-danger">{{ errors[0] }}</small>
                                            </validation-provider>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                            </b-col>
                        </b-row>
                        <b-row  v-if="selectedSliderLinkType.type === 'content'">
                            <b-col cols="12">
                                <b-form-group label="İçerik" label-for="content">
                                    <validation-provider #default="{ errors }" :rules="{
                                        required: true
                                    }" name="İçerik">
                                        <v-select id="content" v-model="selectedContent" label="title"
                                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :options="contents" />
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12">
                                <DragDropImage ref="refCardImage" title="Slider Görseli" :imageUrl="null"
                                    :required="true">
                                </DragDropImage>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12">
                                <b-button v-ripple.400="'rgba(113, 102, 240, 0.15)'" variant="outline-primary"
                                    @click="postConfirmText()">
                                    <b-spinner v-if="spinner == true" small />
                                    {{ spinner == true ? "Ekleniyor" : "Ekle" }}
                                </b-button>
                            </b-col>
                        </b-row>
                    </b-card>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12">
                    <b-card class="mb-3" title="İçerik Listesi">
                        <table class="table b-table">
                            <thead>
                                <th>#</th>
                                <th>GÖRSEL</th>
                                <th>İÇERİK ADI</th>
                                <th>İŞLEMLER</th>
                            </thead>
                            <draggable v-if="sliders.length > 0" v-model="sliders" class="cursor-move" tag="tbody"
                                @change="outputData">
                                <tr v-for="slider in sliders" :key="slider.id">
                                    <td>{{ slider.id }}</td>
                                    <td><img :src="slider.images.hero"></td>
                                    <td>{{ slider.sliderLinkType.type === 'content' ? slider.content.title : slider.category.name }}</td>
                                    <td>
                                        <b-button v-ripple.400="'rgba(113, 102, 240, 0.15)'" variant="outline-danger"
                                            class="btn-icon rounded-circle" @click="deleteConfirmText(slider.id)">
                                            <feather-icon icon="TrashIcon" />
                                        </b-button>
                                    </td>
                                </tr>
                            </draggable>
                            <thead>
                                <th>#</th>
                                <th>GÖRSEL</th>
                                <th>İÇERİK ADI</th>
                                <th>İŞLEMLER</th>
                            </thead>
                        </table>
                    </b-card>
                </b-col>
            </b-row>
        </validation-observer>
    </div>
</template>
<script>
import DragDropImage from "../../components/DragDropImage";
import draggable from "vuedraggable";
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
    BImg,
    BRow,
    BCol,
    BTime,
    BCard,
    BCardText,
    BButton,
    BForm,
    BMedia,
    BAlert,
    BSpinner,
    BFormInput,
    BFormGroup,
    BInputGroup,
    BFormTextarea,
    BMediaAside,
    BMediaBody,
    BFormFile,
    BFormDatepicker,
    BLink
} from "bootstrap-vue";
import {
    required,
    email,
    confirmed,
    url,
    between,
    alpha,
    integer,
    password,
    min,
    digits,
    alphaDash,
    length,
} from "@validations";

import { Endpoints } from "@core/endpoints/endpoints";
const endpoints = new Endpoints();

export default {
    components: {
        BImg,
        BRow,
        BCol,
        BTime,
        BLink,
        BCard,
        BCardText,
        BButton,
        BForm,
        BSpinner,
        BAlert,
        BFormGroup,
        BFormInput,
        BInputGroup,
        BFormTextarea,
        BMedia,
        BMediaAside,
        BMediaBody,
        BFormFile,
        BFormDatepicker,
        vSelect,
        ValidationProvider,
        ValidationObserver,
        required,
        email,
        confirmed,
        url,
        between,
        alpha,
        integer,
        password,
        min,
        digits,
        alphaDash,
        length,
        draggable,
        DragDropImage
    },
    directives: {
        Ripple,
    },
    data() {
        return {
            spinner: false,
            request:[],
            sliders: [],
            contents: [],
            categories: [],
            sliderLinkTypes: [],
            selectedContent: null,
            selectedCategory: null,
            selectedSliderLinkType: null
        };
    },
    watch: {
        selectedCategory(newSelectedCategory, oldSelectedCategory) {
            this.getContentsByCategorySlug(newSelectedCategory.slug)
        }
    },
    methods: {
        outputData() {
            this.updateSubmit()
        },
        updateSubmit() {
            this.request = []
            Object.entries(this.sliders).forEach(([key, value]) => {
                let sliderOrder = {
                    id: value.id,
                    order: parseInt(key),
                };
                this.request.push(sliderOrder);
            });
            endpoints
                .putSettingsSliderInterestedsOrder({ sliders: this.request }, this.$i18n.locale, () => { })
                .then((data) => {
                    this.$swal({
                        icon: "success",
                        title: "Güncelleme başarılı!",
                        text: "Slider sıralaması güncellendi.",
                        customClass: {
                            confirmButton: "btn btn-success",
                        },
                    });
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        getCategories() {
            endpoints
                .getCategories(null, this.$i18n.locale, () => { })
                .then((data) => {
                    this.categories = []
                    this.categories = [...data.response]
                    this.selectedCategory = this.categories[0]
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        getSliderLinkTypes() {
            endpoints
                .getSliderLinkTypes(null, this.$i18n.locale, () => { })
                .then((data) => {
                  
                    let responseArry =  [...data.response]

                    const eventIndex = responseArry.findIndex(object => {
                        return object.type === 'event'
                    });
                    responseArry.splice(eventIndex, 1);
                    
                    const externalIndex = responseArry.findIndex(object => {
                        return object.type === 'external'
                    });
                    responseArry.splice(externalIndex, 1);

                    this.sliderLinkTypes = [...responseArry]
                    this.selectedSliderLinkType = this.sliderLinkTypes[0]
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        getSettingsSliderInteresteds() {
            endpoints.
                getSettingsSliderInteresteds(null, this.$i18n.locale, () => { })
                .then((data) => {
                    this.sliders = [];
                    this.sliders = [...data.response];

                })
                .catch((err) => {
                    console.log(err);
                });
        },
        getContentsByCategorySlug(slug) {
            endpoints.
                getContentsByCategorySlug(slug, this.$i18n.locale, () => { })
                .then((data) => {
                    this.contents = [];
                    this.contents = [...data.response];
                    this.selectedContent = this.contents[0]
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        postConfirmText() {
            this.$swal({
                title: "Kayıt?",
                text: "Slider listesine içeriği eklemek istediğinize emin misiniz?",
                icon: "warning",
                showCancelButton: true,
                cancelButtonText: "Vazgeç!",
                confirmButtonText: "Kaydet!",
                customClass: {
                    confirmButton: "btn btn-primary",
                    cancelButton: "btn btn-outline-danger ml-1",
                },
                buttonsStyling: false,
            }).then((result) => {
                if (result.value) {
                    this.postSubmit();
                }
            });
        },
        postSubmit() {
            this.$refs.rules.validate().then((success) => {
                if (success) {
                    this.spinner = true;
                    let formData = new FormData();
                    formData.append("image", this.$refs.refCardImage.image)
                    formData.append("sliderLinkTypeId", this.selectedSliderLinkType.id)
                    if(this.selectedSliderLinkType.type  === 'content'){
                        formData.append("contentId", this.selectedContent.id)
                    }
                    if(this.selectedSliderLinkType.type  === 'category'){
                        formData.append("categoryId", this.selectedCategory.id)
                    }
                    endpoints
                        .postSettingsSliderInteresteds(formData, this.$i18n.locale, () => { })
                        .then((data) => {
                            this.spinner = false;
                            this.$swal({
                                icon: "success",
                                title: "Kayıt başarılı!",
                                text: "Yeni slider eklendi.",
                                customClass: {
                                    confirmButton: "btn btn-success",
                                },
                            }).then((result) => {
                                this.getSettingsSliderInteresteds()
                            });
                        })
                        .catch((err) => {
                            this.spinner = false;
                            console.log(err);
                        });
                }
            });
        },
        deleteConfirmText(id) {
            this.$swal({
                title: "Sil?",
                text: "Slideri silmek istediğinize emin misiniz?",
                icon: "warning",
                showCancelButton: true,
                cancelButtonText: "Vazgeç!",
                confirmButtonText: "Kaydet!",
                customClass: {
                    confirmButton: "btn btn-primary",
                    cancelButton: "btn btn-outline-danger ml-1",
                },
                buttonsStyling: false,
            }).then((result) => {
                if (result.value) {
                    this.deleteSubmit(id);
                }
            });
        },
        deleteSubmit(id) {
            endpoints
                .deleteSettingsSliderInteresteds(id, this.$i18n.locale, () => { })
                .then((data) => {
                    this.getSettingsSliderInteresteds()
                    this.$swal({
                        icon: "success",
                        title: "Silme başarılı!",
                        text: "Slider silindi",
                        customClass: {
                            confirmButton: "btn btn-success",
                        },
                    });
                })
                .catch((err) => {
                    console.log(err);
                });
        },
    },
    created() { },
    destroyed() { },
    mounted() {
        this.getCategories()
        this.getSliderLinkTypes()
        this.getSettingsSliderInteresteds()
    },
    setup() {
    }
};
</script>
<style lang="css">
.ql-container {
    margin-top: 30px;
}

.ql-container,
.ql-editor {
    min-height: 300px !important;
    margin-bottom: 30px;
}
</style>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/quill.scss";
</style>
<style>
.draggable-card {
    margin-bottom: 0;
}

.draggable-card>.card-body {
    padding: 10px;
}

.draggable-card>.card-body>.card-title {
    margin-bottom: 0;
    font-size: 1rem;
}

.tree-node {
    border: 0 !important;
}
</style>
